<template>
  <generic-container
    :title="$t('robocredit') + ' / ' + $t('new customers')"
    icon="robot"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
    :header_buttons="header_buttons"
    :show_back="true"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("soc instance id") }}</th>
          <th>{{ $t("promissory note") }}</th>
          <th>{{ $t("start date") }}</th>
          <th>{{ $t("dpi") }}</th>
          <th>{{ $t("name") }}</th>
          <!-- <th>{{ $t("email") }}</th> -->
          <th>{{ $t("last update date") }}</th>
          <th>{{ $t("process") }}</th>
          <th>{{ $t("status") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <instance-modal ref="instance_modal" @deleted="refresh" />
  </generic-container>
</template>

<script>
// import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "../configuration_modal/Index.vue";
import InstanceModal from "./instance_modal/InstanceModalIndex.vue";
import { init_ajax_data_datables, enterprise_setup } from "@/utils";
import filters from "@/filters";

export default {
  name: "RobocreditNewCustomers",
  components: { "generic-container": GenericContainer, InstanceModal },
  data() {
    return {
      configure_modal: ConfigureModal,
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.refresh,
        },
        {
          icon: "cogs",
          tooltip: this.$t("catalogs"),
          click: this.catalogs,
        },
      ],
      datatable: {},
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    refresh() {
      this.init();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return row.soc_instance_id;
          },
        },
        {
          data: function (row) {
            return row.promissory_note || "";
          },
        },
        {
          data: function (row) {
            return filters.formatDate(
              row.start_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function (row) {
            return row.dpi;
          },
        },
        {
          data: function (row) {
            return row.name;
          },
        },
        // {
        //   data: function(row) {
        //     return row.email;
        //   },
        // },
        {
          data: function (row) {
            if (row.ngn_instance) {
              return filters.formatDate(
                row.ngn_instance.last_update_date,
                vm.enterprise_setup.detailed_date_format,
              );
            } else {
              return "";
            }
          },
        },
        {
          data: function (row) {
            if (row.ngn_instance) {
              let r = vm.activity(row.ngn_instance.ngn_interaction);
              return `<i class="${r.icon} icon"> </i> ${r.name}`;
            } else {
              return "";
            }
          },
        },
        {
          data: function (row) {
            if (row.ngn_instance) {
              let r = vm.status(row.ngn_instance.status_code);
              return `<i class="${r.icon} icon"> </i> ${r.name}`;
            } else {
              return "";
            }
          },
        },
      ];

      let onSelect = (data) => {
        vm.$refs.instance_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["robocredit url"],
        columns,
        onSelect,
      );
    },
    status(status_code) {
      if (status_code == "C")
        return { name: this.$t("created"), icon: "bullseye icon" };
      else if (status_code == "R")
        return { name: this.$t("running"), icon: "loading cog icon" };
      else if (status_code == "W")
        return { name: this.$t("waiting"), icon: "clock outline icon" };
      else if (status_code == "E")
        return { name: this.$t("errored"), icon: "remove icon" };
      else if (status_code == "F")
        return { name: this.$t("finished"), icon: "check icon" };
      else return { name: "?", icon: "question mark icon" };
    },
    activity(interaction) {
      if (!interaction) return { name: "-", icon: "asterisk icon" };
      let component = interaction.component;

      if (component.$type == "bpmn:UserTask")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "user icon",
        };
      else if (component.$type == "bpmn:StartEvent")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "bullseye icon",
        };
      else if (component.$type == "bpmn:SequenceFlow")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "right arrow icon",
        };
      else if (component.$type == "bpmn:EndEvent")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "flag checkered icon",
        };
      else if (component.$type == "bpmn:SubProcess")
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "setting icon",
        };
      else if (
        component.$type == "bpmn:ServiceTask" &&
        component.custom_type == "AutomatonCall"
      )
        return {
          name: component.name || interaction.component_name || component.$type,
          icon: "settings icon",
        };
      else return { name: "?", icon: "question mark icon" };
    },
    catalogs() {
      this.$router.push({ name: "RobocreditCatalogs", replace: true });
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
};
</script>
